import React, { FC, useState } from 'react'
import AvatarConnector, { ConnectorProps as AvatarProps } from 'connectors/Avatar'
import { LoadingSpinner } from 'styles/loader'
import { uploadAvatarImage } from 'apis/private/uploadAvatar'
import { PencilIcon, Avatar } from './styles'
import { updateImagePathBasedOnHostName } from '../../apps/public/profile/curatorProfile/helpers'

type Props = AvatarProps & {
  userID: number
  avatar: string
}

const uploadAvatarImageApi = async ({
  imageFile,
  callbackFunc,
  addMessage,
}: Record<string, any>) => {
  const heroImageApi = await uploadAvatarImage(imageFile)

  if (heroImageApi.success) {
    const { medImage } = heroImageApi.payload
    callbackFunc({
      avatarImg: medImage,
    })
  } else {
    const { errorMessage } = heroImageApi.payload
    let flashErrorMessage = 'Profile image could not be uploaded'

    if (errorMessage) {
      flashErrorMessage = errorMessage
    }

    addMessage(flashErrorMessage, 'error')
    callbackFunc({
      isLoading: false,
    })
  }
}

const Component: FC<Props> = (props) => {
  const { userID, sessionUserID, avatar, addMessage } = props
  const [state, handleState] = useState({
    isLoading: false,
    avatarImg: avatar,
  })
  const { isLoading, avatarImg } = state
  const myOwnAccount = sessionUserID === Number(userID)

  const onFileChanged = async (ev: React.SyntheticEvent<HTMLInputElement>) => {
    ev.preventDefault()

    if (ev.target.files && ev.target.files.length) {
      const { files } = ev.target
      const imageFile = files[0]
      handleState((prevState) => ({ ...prevState, isLoading: true }))
      uploadAvatarImageApi({
        imageFile,
        callbackFunc: (data: Record<string, any>) => {
          handleState((prevState) => ({ ...prevState, isLoading: false, ...data }))
        },
        addMessage,
      })
    }
  }

  return (
    <Avatar>
      {isLoading && (
        <>
          <div data-type='overlay' />
          <LoadingSpinner data-type='loader' />
        </>
      )}
      <img
        src={updateImagePathBasedOnHostName(avatarImg)}
        data-type='user-avatar'
        alt='profile avatar'
        role='presentation'
        itemProp='image'
      />
      {myOwnAccount ? (
        <>
          <input
            data-type='upload-input'
            type='file'
            accept='image/png, image/jpeg, image/jpg'
            onChange={onFileChanged}
            aria-label='hidden'
          />
          <div data-type='edit-avatar-link' title='edit avatar'>
            <PencilIcon />
          </div>
        </>
      ) : (
        ''
      )}
    </Avatar>
  )
}

export default AvatarConnector(Component)
